import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import Button from '../../components/Button'
import Card from '../../components/Card'
import Input from '../../components/Input'
import Row from '../../components/Row'
import request from '../../utils/request'

@observer
export default class UserInfo extends Component {
  @observable error = false
  @observable loading = false
  @observable success = false
  @observable changed = false

  @observable
  fields = {
    firstName: '',
    lastName: '',
  }

  @action
  setInitialFields = fields => {
    this.fields.firstName = fields.firstName
    this.fields.lastName = fields.lastName
  }

  @action
  setField = event => {
    this.error = false
    this.success = false
    this.changed = true
    this.fields[event.target.name] = event.target.value
  }

  @action
  setLoading = () => {
    this.loading = true
    this.error = false
    this.success = false
  }

  @action
  setError = () => {
    this.loading = false
    this.error = true
  }

  @action
  setSuccess = () => {
    this.loading = false
    this.error = false
    this.success = true
    this.changed = false
  }

  submit = async event => {
    event.preventDefault()
    this.setLoading()
    const res = await request('/api/user/updateInfo', this.fields)

    if (res.success) {
      this.setSuccess()
    } else {
      this.setError()
    }
  }

  componentDidMount() {
    const { fields } = this.props
    this.setInitialFields(fields)
  }

  render() {
    return (
      <Card>
        <form onSubmit={this.submit}>
          {this.error && <Card.ErrorMessage />}
          {this.success && <Card.SavedMessage />}
          <Card.Pad>
            <Row>
              <Row.Cell>
                <Input
                  name="firstName"
                  label="titles.firstName"
                  disabled={this.loading}
                  value={this.fields.firstName}
                  onChange={this.setField}
                />
              </Row.Cell>
              <Row.Cell>
                <Input
                  name="lastName"
                  label="titles.lastName"
                  disabled={this.fields.loading}
                  value={this.fields.lastName}
                  onChange={this.setField}
                />
              </Row.Cell>
            </Row>
          </Card.Pad>
          {this.changed &&
            <Fragment>
              <Card.Divider />
              <Card.Pad>
                <Button
                  color="blue"
                  disabled={this.loading}
                  str="titles.save"
                  type="submit"
                />
              </Card.Pad>
            </Fragment>
          }
        </form>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Profile/UserInfo.js